import {
  EVENT_CATEGORY_CLASS_TODO,
  EVENT_ACTION_OPEN,
} from 'approot/shared/data-tracker/data-events.constants';
import { ActivitiesContentType, AssignmentType } from 'global/constants';
import AssignButton, {
  AssignVariant,
} from 'approot/shared/assign/assign-button';

type Props = {
  contentType: AssignmentType | ActivitiesContentType;
  contentId: number;
  bookmarked: boolean;
  isSmall?: boolean;
  variant?: AssignVariant;
  assignButtonLocation?: 'card' | 'content' | 'activity-page';
  onAssignSelect: () => void;
};

const BookmarkButton = ({
  bookmarked,
  contentType,
  contentId,
  isSmall,
  variant,
  assignButtonLocation,
  onAssignSelect,
}: Props) => {
  return (
    <AssignButton
      assigned={bookmarked}
      isSmall={isSmall}
      variant={variant}
      dataEvent={
        assignButtonLocation
          ? {
              category: EVENT_CATEGORY_CLASS_TODO,
              action: EVENT_ACTION_OPEN,
              data: {
                target_type: contentType,
                target_identifier: contentId,
                assign_button_location: assignButtonLocation,
              },
            }
          : undefined
      }
      onAssignSelect={onAssignSelect}
    />
  );
};

export default BookmarkButton;
